/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import PropTypes from "prop-types";
import React from "react";
import "./style.css";

export const Checkbox = ({ property1, className }) => {
  return <div className={`checkbox ${property1} ${className}`} />;
};

Checkbox.propTypes = {
  property1: PropTypes.oneOf(["fi-sr-checkbox", "fi-rr-checkbox","fi-sr-info"]),
};
